import React from 'react'
import { Button, Typography } from '@mui/material'
import Dialog from 'components/Dialog'
import useFavurTranslation from 'hooks/useFavurTranslation'
import { VERSION_REQUIREMENT_TRANSLATIONS as translations } from '../constants'
import useVersionRequirement from './useVersionRequirement'

const VersionRequirementDialog: React.FC<{ dismiss: () => void }> = ({ dismiss }) => {
  const { t } = useFavurTranslation()
  const { callback, callToAction } = useVersionRequirement(dismiss)

  return (
    <Dialog
      actions={
        <>
          <Button color="secondary" onClick={dismiss} size="large" data-testid="version-req-dlg-dimiss-button">
            {t(translations.close)}
          </Button>
          <Button color="secondary" onClick={callback} size="large">
            {t(callToAction)}
          </Button>
        </>
      }
      open
      title={t(translations.title)}
    >
      <Typography variant="body2">{t(translations.content)}</Typography>
    </Dialog>
  )
}

export default VersionRequirementDialog
